module.exports = __webpack_public_path__ + "img/logo.93507085.png";